import { render, staticRenderFns } from "./RecJobOverview.vue?vue&type=template&id=24affb0e&scoped=true"
import script from "./RecJobOverview.vue?vue&type=script&lang=js"
export * from "./RecJobOverview.vue?vue&type=script&lang=js"
import style0 from "./RecJobOverview.vue?vue&type=style&index=0&id=24affb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24affb0e",
  null
  
)

export default component.exports